export default [
	{//系统用户
		path: 'users',
		name: 'm_sysuser',
		meta: {
			templateManage: {
				workType: 27,
				print: 'b_sysuser_printtemplate',
				export: 'b_sysuser_exporttemplate'
			}
		},
		props: route => route.params,
		component: () => import('@/pages/system/sysuser_list')
	}, {//部门管理
		path: 'department',
		name: 'm_department',
		props: route => route.params,
		component: () => import('@/pages/system/department_list')
	}, {
		path: 'factory',
		name: 'm_factory',
		props: route => route.params,
		component: () => import('@/pages/system/factory_info')
	},{
		path: 'position_level_list',
		name: 'm_position',
		component: () => import('@/pages/system/position_level_list.vue')
	},
	{ //售后服务网点
		path: '/aftersale/outlet/list',
		name: 'm_aftersale_outlet',
		meta: {
			appView: {
				viewId: '10005',
				auth: 'b_aftersale_outlet_viewmanage'
			}
		},
		component: () => import('@/pages/aftersale/aftersale_outlet_list.vue'),
	},
	{
		path: 'sys_config',
		name: 'm_system_config',
		props: route => route.params,
		component: () => import('@/pages/system/system_config.vue')
	},{
		path: 'holiday',
		name: 'm_holiday_config',
		props: route => route.params,
		component: () => import('@/pages/system/holiday_list.vue')
	},{
		path: 'role_manage',
		name: 'm_role_manage',
		props: route => route.params,
		component: () => import('@/pages/system/role_list.vue')
	},//平台协议列表
	{
		path: 'agreement',
		name: 'm_legal_agreement',
		props: route => route.params,
		component: () => import('@/pages/basic/legal_agreement_list.vue')
	},
	//mq错误日志
	{
		path: 'mq_error_log',
		name: 'm_mq_error_log',
		props: route => route.params,
		component: () => import('@/pages/system/mq_error_log_list.vue')
	},
];